/** Deve permanecer alinhado com o backend (ver docs/nsirDocumentoKmzNameBackend.kt). */
export const PLACEHOLDER = 'N/A';

const isPresent = value =>
  value != null && String(value).trim() !== '';

/**
 * Nome base sem extensão: NSIR {codigo} - {alimentador} - {equipamento}
 * Segmento ausente → PLACEHOLDER
 * Uso Mútuo não tem alimentador nem equipamento: somenteLote deixa NSIR {codigo}
 */
export const buildNsirDocumentoKmzBaseName = ({ codigo, equipamento, alimentadorCodigo, somenteLote }) => {
  const codigoSeg = isPresent(codigo) ? String(codigo).trim() : PLACEHOLDER;
  if (somenteLote) return `NSIR ${codigoSeg}`;
  const alimentadorSeg = isPresent(alimentadorCodigo)
    ? String(alimentadorCodigo).trim()
    : PLACEHOLDER;
  const equipSeg = isPresent(equipamento) ? String(equipamento).trim() : PLACEHOLDER;
  return `NSIR ${codigoSeg} - ${alimentadorSeg} - ${equipSeg}`;
};

const resolveAlimentadorCodigo = ({
  alimentadorCodigo,
  alimentadorId,
  alimentadoresOptions,
}) => {
  if (isPresent(alimentadorCodigo)) {
    return String(alimentadorCodigo).trim();
  }
  if (isPresent(alimentadorId) && Array.isArray(alimentadoresOptions)) {
    const opt = alimentadoresOptions.find(
      o =>
        o != null &&
        (o.id === alimentadorId || String(o.id) === String(alimentadorId))
    );
    if (opt && isPresent(opt.codigo)) {
      return String(opt.codigo).trim();
    }
  }
  return null;
};

const extensionFromOriginalName = originalFileName =>
  originalFileName && originalFileName.includes('.')
    ? originalFileName.substring(originalFileName.lastIndexOf('.'))
    : '';

/**
 * Nome completo para documento KMZ (e extensões aceitas no dropzone).
 * @param {object} params
 * @param {string} [params.codigo]
 * @param {string} [params.equipamento]
 * @param {string} [params.alimentadorCodigo] — se vier do DTO/API, tem prioridade sobre id+options
 * @param {string} [params.alimentadorId]
 * @param {Array} [params.alimentadoresOptions]
 * @param {string} originalFileName — nome original do arquivo (apenas para extrair extensão)
 */
export const buildNsirDocumentoKmzFileName = (params, originalFileName) => {
  const alimentadorCodigo = resolveAlimentadorCodigo(params);
  const base = buildNsirDocumentoKmzBaseName({
    codigo: params.codigo,
    equipamento: params.equipamento,
    alimentadorCodigo,
    somenteLote: params.somenteLote,
  });
  return `${base}${extensionFromOriginalName(originalFileName)}`;
};
